import React from "react";
import { IProps } from "./types";
import { MessageDescriptor, useIntl } from "react-intl";
import ChoirIcon from "../../../../components/ChoirIcon";
import Icon from "../../../../../icon";
import Tooltip from "../../../../../components/Tooltip";
import { Container } from "./styles";
import messages from "./messages";

export const getIconedDetail = (tooltip: MessageDescriptor, label?: MessageDescriptor | MessageDescriptor[] | string, icon = "style") => {
    const { formatMessage } = useIntl();
    let labelText = formatMessage(messages.notProvided);
    if (Array.isArray(label)) {
        if (label.length > 0) {
            labelText = label.map(l => formatMessage(l)).join(", ");
        }
    } else if (typeof label === 'object') {
        labelText = formatMessage(label)
    } else {
        labelText = label;
    }
    return (
        <IconedDetail
            tooltip={tooltip && formatMessage(tooltip)}
            label={labelText}
            icon={icon}
            key={labelText}
        />
    )
};

type Options<T> = {
    value: T,
    label: MessageDescriptor
}[];

export function getLabel<T>(options: Options<T>, value: T[]): MessageDescriptor[];
export function getLabel<T>(options: Options<T>, value: T): MessageDescriptor;

export function getLabel<T>(options: Options<T>, value?: T | T[]) {
    if (Array.isArray(value)) {
        return options.filter(o => value.includes(o.value)).map(o => o.label);
    }
    if (!value) {
        return undefined;
    }
    return options.find(o => o.value === value).label;
}

const IconedDetail = ({ icon, label, tooltip }: IProps) => {
    let iconComp = null;
    if (icon?.includes('choir-')) {
        iconComp = <ChoirIcon i={icon.replace("choir-", "")} />
    } else {
        iconComp = <Icon i={icon} />
    }
    return (
        <Container>
            <Tooltip label={tooltip} flipped>
                {iconComp}
            </Tooltip>
            <span>{label}</span>
        </Container>
    );
};

export default IconedDetail;
